import axiosInstance from './axiosInstance'
import { FalabellaApiResponse, FalabellaFilters, FalabellaTrackingResponse } from '../types/falabella'

class FalabellaService {
  private baseUrl = '/falabella'

  /**
   * Obtiene productos de Falabella con filtros opcionales
   */
  async getProducts(filters: FalabellaFilters = {}): Promise<FalabellaApiResponse> {
    try {
      const params = new URLSearchParams()
      
      // Agregar filtros como parámetros de query
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          if (key === 'skuSellerList' && Array.isArray(value)) {
            params.append(key, JSON.stringify(value))
          } else {
            params.append(key, String(value))
          }
        }
      })

      const response = await axiosInstance.get(`${this.baseUrl}/products?${params.toString()}`)
      return response.data
    } catch (error: any) {
      console.error('Error obteniendo productos de Falabella:', error)
      throw error
    }
  }

  /**
   * Obtiene un producto específico por SKU
   */
  async getProductBySku(sku: string): Promise<FalabellaApiResponse> {
    try {
      const response = await axiosInstance.get(`${this.baseUrl}/products/${sku}`)
      return response.data
    } catch (error: any) {
      console.error('Error obteniendo producto de Falabella:', error)
      throw error
    }
  }

  /**
   * Actualiza el stock de un producto
   */
  async updateStock(sku: string, quantity: number): Promise<FalabellaApiResponse> {
    try {
      const response = await axiosInstance.post(`${this.baseUrl}/products/stock/default`, {
        stockUpdates: [
          {
            sellerSku: sku,
            quantity: quantity
          }
        ]
      })
      return response.data
    } catch (error: any) {
      console.error('Error actualizando stock de Falabella:', error)
      throw error
    }
  }

  /**
   * Obtiene el número de seguimiento por ID de pedido de Falabella
   */
  async getTrackingByOrderId(falabellaOrderId: string, shippingProvider?: string): Promise<FalabellaTrackingResponse> {
    try {
      const response = await axiosInstance.post(`${this.baseUrl}/tracking/get-by-falabella-order-id`, {
        falabellaOrderId,
        shippingProvider
      })
      return response.data
    } catch (error: any) {
      console.error('Error obteniendo tracking de Falabella:', error)
      throw error
    }
  }

  /**
   * Obtiene la etiqueta de envío por ID de pedido de Falabella
   */
  async getShippingLabelByOrderId(falabellaOrderId: string, format: string = 'JSON'): Promise<any> {
    try {
      const response = await axiosInstance.post(`${this.baseUrl}/document/shipping-label-by-order-id`, {
        falabellaOrderId,
        format
      })
      return response.data
    } catch (error: any) {
      console.error('Error obteniendo etiqueta de envío de Falabella:', error)
      throw error
    }
  }

  /**
   * Busca productos por término de búsqueda (POST)
   */
  async searchProducts(searchTerm: string, limit: number = 100, offset: number = 0): Promise<FalabellaApiResponse> {
    try {
      const response = await axiosInstance.post(`${this.baseUrl}/products/search`, {
        searchTerm,
        limit,
        offset
      })
      return response.data
    } catch (error: any) {
      console.error('Error buscando productos de Falabella:', error)
      throw error
    }
  }

  /**
   * Obtiene productos por SKUs específicos
   */
  async getProductsBySkus(skus: string[]): Promise<FalabellaApiResponse> {
    try {
      const response = await axiosInstance.post(`${this.baseUrl}/products/by-skus`, {
        skus
      })
      return response.data
    } catch (error: any) {
      console.error('Error obteniendo productos por SKUs de Falabella:', error)
      throw error
    }
  }

  /**
   * Obtiene productos por estado
   */
  async getProductsByStatus(status: string): Promise<FalabellaApiResponse> {
    try {
      const response = await axiosInstance.post(`${this.baseUrl}/products/by-status`, {
        status
      })
      return response.data
    } catch (error: any) {
      console.error('Error obteniendo productos por estado de Falabella:', error)
      throw error
    }
  }

}

const falabellaService = new FalabellaService()
export default falabellaService
